import './NotificationSkeletonWave.css';

const NotificationSkeletonWave = ({ notificationsType }) => {
  const shouldShowRightThumb = notificationsType !== "social" && notificationsType !== "clinical-session";
  return (
    <div className="notif-item-card notif-card-skeleton">
      <div className="notif-item-identity">
        <div className="notif-skeleton-avatar skeleton-wave" />
      </div>
      <div className="notif-item-body">
        <div className="notif-skeleton-line-actor skeleton-wave" />
        <div className="notif-skeleton-line-action skeleton-wave" />
        <div className="notif-skeleton-line-time skeleton-wave" />
      </div>
      <div className="notif-item-right">
        {shouldShowRightThumb && (
          <div className="notif-skeleton-thumb skeleton-wave" />
        )}
        <div className="notif-skeleton-chevron skeleton-wave" />
      </div>
    </div>
  );
};

export default NotificationSkeletonWave;
